import React, { useState, Fragment, useEffect } from "react";
import { getTitleTable, getDataSource, columnsTable, genaratePaginateFilterSort, checkUndefine, formatValidation } from "../../../../../helpers/functions";
import { FilterDropdown, ListComponent, StatusComponent } from "../../../common/component/Index";
import { useTranslation } from "react-i18next";
import { Icon, Menu } from "antd";
import Bundle from "../../../../../models/Bundle";
import './BundleList.less';
import * as ANT from "antd";
import Dropdown from "../../../common/component/Dropdown";
import Modal from "../../../common/component/Modal";
import moment from "moment";
import { DATE_TIME_FORMAT } from "../../../../../constants/Define";
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { PATHS } from '../../../../../constants/Define';

const ListCols = [
    'campaignCode',
    'campaignName',
    'code',
    'name',
    'loyaltyBenefitCode',
    'count',
    'usedCount',
    'rangeDate',
    'rangeStayDate',
    'isActive',
    'createdUserName',
];
const ModelFields = Object.getOwnPropertyNames(new Bundle());
const BundleList = ({ ...props }) => {
    const { promotionState, getListBundle, fetchBundleLst, onViewPromotionCode, permissionActions, changeBundleStatus } = props;
    const { isFetchingBundleList, bundleLst, pageSize, pageIndex, totalCount, totalPage } = promotionState;
    const { t } = useTranslation();
    const [titleItemTable, setTitleItemTable] = useState(getTitleTable(ListCols, ['action'], []),);
    const [componentTable, setComponentTable] = useState(
        {
            campaignCode: {
                key: 'campaignCode',
                render: (text, record) => text,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropdown
                        setSelectedKeys={ setSelectedKeys }
                        selectedKeys={ selectedKeys }
                        confirm={ confirm }
                        clearFilters={ clearFilters }
                    >
                    </FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={ { color: filtered ? '#1890ff' : undefined } }/>
                ),
            },
            campaignName: {
                key: 'campaignName',
                render: (text, record) => text,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropdown
                        setSelectedKeys={ setSelectedKeys }
                        selectedKeys={ selectedKeys }
                        confirm={ confirm }
                        clearFilters={ clearFilters }
                    >
                    </FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={ { color: filtered ? '#1890ff' : undefined } }/>
                ),
            },
            name: {
                key: 'name',
                render: (text, record) => text,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropdown
                        setSelectedKeys={ setSelectedKeys }
                        selectedKeys={ selectedKeys }
                        confirm={ confirm }
                        clearFilters={ clearFilters }
                    >
                    </FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={ { color: filtered ? '#1890ff' : undefined } }/>
                ),
            },
            code: {
                key: 'code',
                render: (text, record) => text,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropdown
                        setSelectedKeys={ setSelectedKeys }
                        selectedKeys={ selectedKeys }
                        confirm={ confirm }
                        clearFilters={ clearFilters }
                    >
                    </FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={ { color: filtered ? '#1890ff' : undefined } }/>
                ),
            },
            loyaltyBenefitCode: {
                key: 'loyaltyBenefitCode',
                render: (text, record) => text,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropdown
                        setSelectedKeys={ setSelectedKeys }
                        selectedKeys={ selectedKeys }
                        confirm={ confirm }
                        clearFilters={ clearFilters }
                    >
                    </FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={ { color: filtered ? '#1890ff' : undefined } }/>
                ),
            },
            count: {
                key: 'count',
                render: (text, record) => text,
            },
            usedCount: {
                key: 'usedCount',
                render: (text, record) => text,
            },
            rangeDate: {
                width: 200,
                key: 'rangeDate',
                render: (text, record) => (
                    record.startDate && record.endDate && Date.parse(record.startDate) > 0 && Date.parse(record.endDate) > 0
                        ? `${ moment(record.startDate).format(DATE_TIME_FORMAT.SHORT_DATE) } - ${ moment(record.endDate).format(DATE_TIME_FORMAT.SHORT_DATE) }` : ''
                ),
            },
            rangeStayDate: {
                width: 200,
                key: 'rangeStayDate',
                render: (text, record) => (
                    record.stayStartDate && record.stayEndDate && Date.parse(record.stayStartDate) > 0 && Date.parse(record.stayEndDate) > 0
                        ? `${ moment(record.stayStartDate).format(DATE_TIME_FORMAT.SHORT_DATE) } - ${ moment(record.stayEndDate).format(DATE_TIME_FORMAT.SHORT_DATE) }` : ''
                ),
            },
            isActive: {
                key: 'isActive',
                render: (text, record) => (
                    <StatusComponent color={ text ? 'green' : 'red' } label={ text ? t('item.bundle.activated') : t('item.bundle.deactivated') }/>
                ),
                filters: [
                    { value: true, text: t('item.bundle.activated') },
                    { value: false, text: t('item.bundle.deactivated') },
                ],
                filterMultiple: false,
            },
            createdUserName: {
                key: 'createdUserName',
                render: (text, record) => text,
            },
            action: {
                width: 100,
                fixed: 'right',
                align: 'center',
                key: 'action',
                render: (text, record) => renderEditComponent(record),
            }
        }
    );
    const [modelItem, setModelItem] = useState(ModelFields);
    const [dataFilter, setDataFilter] = useState({
        filters: {
            pageSize: promotionState.pageSize,
            pageIndex: promotionState.pageIndex,
        },
    })
    const [isFetchingData, setIsFetchingData] = useState(false);
    useEffect(() => {
        if (fetchBundleLst) {
            getListBundle(dataFilter.filters);
        }
    }, [fetchBundleLst])

    const onColumnVisibleChange = (column, isVisibled) => {
        const currentComponentTable = componentTable;
        currentComponentTable[column.dataIndex].visible = isVisibled;
        setComponentTable(currentComponentTable);
    }

    const onTableChange = (pagination, filters, sorter) => {
        let newFilters = genaratePaginateFilterSort(pagination, filters, sorter);
        setDataFilter({ filters: newFilters });
        getListBundle({ ...newFilters });
    }

    const renderEditComponent = (item) => {
        const isActive = item.isActive;

        const currentPaging = {
            filters: {
                pageSize: pageSize,
                pageIndex: pageIndex,
            }
        }

        const deactivatedCode = (close) => {
            close();
            changeBundleStatus({ ...item, isActive: false }, currentPaging);
        }

        const activatedCode = (close) => {
            close();
            changeBundleStatus({ ...item, isActive: true }, currentPaging);
        }

        const viewPromotionCode = () => {
            onViewPromotionCode({
                campaignId: item.campaignId,
                bundleId: item.id,
                keyActive: "PROMOTION",
            });
        }

        const onDeactivated = () => {
            const { confirm } = Modal;
            confirm({
                title: formatValidation(t('validation.statusCode.code.DEACTIVATED_BUNDLE'), t(`item.bundle.title`)),
                content: item.campaignName,
                okText: t(`action.save`),
                cancelText: t(`action.cancel`),
                onOk: deactivatedCode,
            });
        };

        const onActivated = () => {
            const { confirm } = Modal;
            confirm({
                title: formatValidation(t('validation.statusCode.code.ACTIVATED_BUNDLE'), t(`item.bundle.title`)),
                content: item.campaignName,
                okText: t(`action.save`),
                cancelText: t(`action.cancel`),
                onOk: activatedCode,
            });
        };
        return (
            <Fragment>
                { permissionActions.allowView && permissionActions.allowUpdateBundle &&
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {/*<Menu.Item onClick={ viewPromotionCode }><Icon type="eye" className="fs20 mr-1 colorPrimary"/>{ t(`action.show`) }</Menu.Item>*/}
                        { permissionActions.allowView &&
                        <Menu.Item onClick={ viewPromotionCode }><Icon type="eye" className="fs20 mr-1 colorPrimary"/>{ t(`action.bundleViewCode`) }</Menu.Item>
                        }
                        {
                            permissionActions && permissionActions.allowUpdateBundle &&
                            <Menu.Item>
                                <Link
                                    to={ {
                                        pathname: Func.getPathWithParams(PATHS.PROMOTION.DETAIL.path, { id: item.id, isFromCampaign: true }),
                                        state: { id: item.id, isFromCampaign: true }
                                    } }
                                >
                                    <Icon type="edit" className="fs20 mr-1 colorPrimary"/> { t(`action.bundleEditCode`) }
                                </Link>
                            </Menu.Item>
                        }
                        { permissionActions.allowUpdateBundle && (isActive ?
                            <Menu.Item onClick={ onDeactivated }><Icon type="lock" className="fs20 mr-1 colorPrimary"/>{ t(`action.bundleDeactivated`) }</Menu.Item> :
                            <Menu.Item onClick={ onActivated }><Icon type="unlock" className="fs20 mr-1 colorPrimary"/>{ t(`action.bundleActivated`) }</Menu.Item>)
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer"/>
                </Dropdown>
                }
            </Fragment>
        )
    }

    return (
        <Fragment>
            <ListComponent
                tableKey="bundle-list"
                scroll={{ x: 2000 }}
                classChildren="p-0" classParent="m-0"
                rowKey={ (record, k) => record.id ? record.id : k }
                loading={ { spinning: isFetchingBundleList, size: 'large' } }
                dataSource={ getDataSource(bundleLst || [], modelItem) }
                columns={ columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'bundle'
                }) }
                onChange={ onTableChange }
                componentTableList={ {} }
                onColumnVisibleChange={ onColumnVisibleChange }
                pagination={ { total: totalCount, totalPage: totalPage, pageSize, current: pageIndex } }
            >
            </ListComponent>
        </Fragment>
    )
}

export default BundleList;
